import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { Auth0Metadata } from '../api/API';
import { Auth0Context, useAuth0 } from './Auth0Provider';
import { MNOHSFloatingIndicator } from './MNOHSFloatingIndicator';

export enum Role {
  Admin = 'ADMIN',
  Student = 'STUDENT',
}

interface Props extends RouteProps {
  allowedRoles: Role[];
}

/**
 * Wrapper for React Router's route component to protect
 * against user from directly accessing a screen without
 * being authenticated
 */
export const PrivateRoute: React.FC<Props> = ({ component, path, allowedRoles }) => {
  const { isLoading, isAuthenticated, user } = useAuth0() as Auth0Context;

  if (isLoading) {
    return <MNOHSFloatingIndicator block={true} padded={true} />;
  } else if (isAuthenticated) {
    // Milos suggested that the default role should be Student
    const roles = user?.[Auth0Metadata.Roles]?.length ? user[Auth0Metadata.Roles] : [Role.Student];

    if (allowedRoles.find(allowedRole => roles.includes(allowedRole))) {
      return <Route path={path} component={component} />;
    } else {
      return <Redirect to={{ pathname: '/404' }} />;
    }
  } else {
    return <Redirect to={{ pathname: '/' }} />;
  }
};
